// extracted by mini-css-extract-plugin
module.exports = {"empty":"GlassesList_empty__mpUqB","scroll":"GlassesList_scroll__eB33M"};